import { useBeeswaxInventorySources } from "@/modules/Beeswax/beeswax.hook";
import {
  SubModule,
  SubModuleCommonProps,
} from "@/modules/Presets/TargetingExpression/targetingExpression.interface";
import { formateDataForCustomSelect } from "@/utils/helpers";
import { Box } from "@mui/material";
import { FieldValues } from "react-hook-form";
import SelectModuleWithType from "../SelectModuleWithType";

const moduleName = "exchange";

export default function Exchange<
  T extends FieldValues,
  U extends SubModule = "EXCHANGE"
>({
  control,
  errors,
  setValue,
  getValues,
  parentName,
  inventorySources,
  inventorySourcesLoading,
  isEdit,
}: ExchangeProps<T, U>) {
  const {
    data: localInventorySources,
    isLoading: localInventorySourcesLoading,
    isFetching: localInventorySourcesFetching,
  } = useBeeswaxInventorySources({
    queryParams: {
      page_size: 300,
      viewable: true,
    },
    options: { enabled: !inventorySourcesLoading && !inventorySources },
  });

  inventorySources =
    isEdit && inventorySources ? inventorySources : localInventorySources;
  inventorySourcesLoading =
    isEdit && inventorySources
      ? inventorySourcesLoading
      : localInventorySourcesLoading && localInventorySourcesFetching;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        height: "100%",
        overflow: "auto",
        padding: 2,
      }}
    >
      <SelectModuleWithType<T>
        itemList={formateDataForCustomSelect(
          inventorySources?.results,
          "name",
          "key"
        )}
        control={control}
        errors={errors}
        name={`${parentName}.${moduleName}.inventory_source`}
        label="Inventory"
        setValue={setValue}
        getValues={getValues}
        loading={inventorySourcesLoading}
      />
    </Box>
  );
}

type ExchangeProps<T extends FieldValues, U> = U extends "EXCHANGE"
  ? Exchange<T>
  : never;
interface Exchange<T extends FieldValues> extends SubModuleCommonProps<T> {
  inventorySources: any;
  inventorySourcesLoading: boolean;
}
